import { Helmet } from "react-helmet-async";
import LegalDoc from "@/components/LegalDoc";

const Terms = () => (
  <>
    <Helmet>
      <title>Terms & Conditions | Zentra</title>
      <meta
        name="description"
        content="Terms and conditions governing use of zentrafoods.in and purchases of Zentra microgreen protein bars."
      />
    </Helmet>
    <LegalDoc
      testId="terms-page"
      title="Terms & Conditions"
      updated="July 2026"
      intro="These Terms & Conditions govern your use of zentrafoods.in and any purchases made through it. This website is operated by Mountain Fresh Farms LLP (brand: ZENTRA), Coimbatore, Tamil Nadu, India. By accessing or using this website, you agree to be bound by these terms."
      sections={[
        {
          heading: "1. Acceptance of Terms",
          paragraphs: [
            "By browsing this website, placing an order or contacting us through it, you confirm that you are at least 18 years old (or are using the site under the supervision of a parent or guardian) and that you accept these Terms & Conditions, our Shipping Policy, Refund Policy and Privacy Policy.",
          ],
        },
        {
          heading: "2. Products & Information",
          paragraphs: [
            "ZENTRA products are food products intended for general nutrition. Product descriptions, nutritional information and health-related statements on this website are provided for general information only and are not medical advice. Please consult a qualified healthcare professional before making dietary changes, especially if you have a medical condition, are pregnant, or are giving products to children.",
            "Allergen notice: our products are manufactured in a facility that also handles nuts, soy, dairy and gluten [REVIEW]. Please check the ingredient list on each product page and pack before consuming.",
            "We make every effort to display products and prices accurately, but packaging, formulations and prices may change from time to time.",
          ],
        },
        {
          heading: "3. Orders",
          paragraphs: [
            "All orders are subject to product availability and acceptance by us. We reserve the right to refuse or cancel any order, including in cases of pricing or listing errors, suspected fraud, or payment authorisation failure. If we cancel a paid order, you will receive a full refund to the original payment method.",
          ],
        },
        {
          heading: "4. Pricing & Payment",
          paragraphs: [
            "All prices are listed in Indian Rupees (INR) and are inclusive of applicable taxes unless stated otherwise [REVIEW].",
            "We accept online payments through PayU (UPI, cards, net banking and wallets) and, where enabled, Cash on Delivery (COD). COD availability may be restricted or withdrawn at our discretion. Online payment transactions are subject to PayU's terms and conditions.",
          ],
        },
        {
          heading: "5. Shipping & Refunds",
          paragraphs: [
            "Shipping of orders is governed by our Shipping Policy, and returns and refunds are governed by our Refund Policy, both available on this website. Please read them before placing an order.",
          ],
        },
        {
          heading: "6. Intellectual Property",
          paragraphs: [
            "The ZENTRA name, logo, website design, text, images and all other content on this website are the property of Mountain Fresh Farms LLP and are protected by applicable intellectual property laws. You may not reproduce, distribute or use any content from this website for commercial purposes without our prior written consent.",
          ],
        },
        {
          heading: "7. Acceptable Use",
          paragraphs: [
            "You agree not to misuse this website, including by attempting unauthorised access, scraping or harvesting data, interfering with the site's operation, or using the site for any unlawful or fraudulent purpose.",
          ],
        },
        {
          heading: "8. Limitation of Liability",
          paragraphs: [
            "To the maximum extent permitted by law, Mountain Fresh Farms LLP shall not be liable for any indirect, incidental or consequential damages arising from your use of this website or consumption of our products. Our total liability for any claim relating to an order shall not exceed the amount you paid for that order [REVIEW].",
          ],
        },
        {
          heading: "9. Governing Law & Jurisdiction",
          paragraphs: [
            "These Terms & Conditions are governed by the laws of India. Any disputes arising out of or relating to these terms or your use of this website shall be subject to the exclusive jurisdiction of the courts of Coimbatore, Tamil Nadu [REVIEW].",
          ],
        },
        {
          heading: "10. Changes to These Terms",
          paragraphs: [
            "We may revise these Terms & Conditions at any time. The updated version will be posted on this page with a revised “Last updated” date, and continued use of the website after changes are posted constitutes acceptance of the updated terms.",
          ],
        },
      ]}
    />
  </>
);

export default Terms;
